import React from "react";
import DashboardCalendar from "../Students/dashboard/DashboardCalendar";
import UpcomingWebinar from "../Students/dashboard/UpcomingWebinar";
import { FaCalendarAlt, FaCalendarCheck, FaInfoCircle } from "react-icons/fa";

export default function CalendarPage() {
  return (
    <div className="container-wrapper p-6 bg-slate-50/50 min-h-screen">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 pb-5 border-b border-slate-200">
        <div>
          <h1 className="text-3xl font-extrabold text-slate-800 flex items-center gap-3 tracking-tight">
            <span className="p-3 bg-gradient-to-tr from-blue-500 to-indigo-600 rounded-2xl text-white shadow-lg shadow-indigo-200">
              <FaCalendarAlt size={22} />
            </span>
            Interactive Event Calendar
          </h1>
          <p className="text-slate-500 mt-2 font-medium">
            Manage your schedule, track live classes, webinars, and keep your learning timeline organized.
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 px-4 py-2.5 rounded-2xl text-sm font-semibold">
          <FaInfoCircle className="text-blue-500 shrink-0" />
          Click on events in the calendar to view their details or join links.
        </div>
      </div>

      {/* Main Content Layout */}
      <div className="flex flex-col xl:flex-row gap-8">
        {/* Calendar Column */}
        <div className="flex-1 bg-white p-6 rounded-3xl shadow-xl shadow-slate-100/70 border border-slate-100 transition-all duration-300 hover:shadow-2xl hover:shadow-slate-200/50">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-2.5 h-7 bg-indigo-600 rounded-full"></span>
            <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
              <FaCalendarCheck className="text-indigo-600" />
              Schedule Overview
            </h2>
          </div>
          <div className="calendar-container-premium">
            <DashboardCalendar />
          </div>
        </div>

        {/* Sidebar Events Column */}
        <div className="w-full xl:w-80 shrink-0 flex flex-col gap-6">
          <div className="bg-white p-6 rounded-3xl shadow-xl shadow-slate-100/70 border border-slate-100 transition-all duration-300 hover:shadow-2xl hover:shadow-slate-200/50">
            <UpcomingWebinar />
          </div>

          {/* Quick Tips or Stats Card */}
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 text-white p-6 rounded-3xl shadow-xl shadow-slate-800/10">
            <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
              <span>💡</span> Calendar Quick Tips
            </h3>
            <ul className="space-y-3.5 text-slate-300 text-sm">
              <li className="flex gap-2">
                <span className="text-amber-400 font-bold">•</span>
                <span>All webinars automatically sync with your local timezone.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-amber-400 font-bold">•</span>
                <span>Use the navigation arrows in the calendar to switch months.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-amber-400 font-bold">•</span>
                <span>You can click "Join" on upcoming webinar cards directly.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
